import React, { useState, useEffect } from 'react';
import { Window, Button, Separator, Checkbox } from 'react95';
import styles from '../styles/modules/Window.module.css';
import { t } from '../data/translations';

interface WindowWelcomeProps {
  onClose: () => void;
  onDontShowAgain: (dontShow: boolean) => void;
}

const WindowWelcome: React.FC<WindowWelcomeProps> = ({ onClose, onDontShowAgain }) => {
  const [dontShow, setDontShow] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth < 500);
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const handleClose = () => {
    onDontShowAgain(dontShow);
    onClose();
  };

  return (
    <Window 
      className={styles.window} 
      style={{ 
        width: isMobile ? '90vw' : '500px', 
        maxWidth: '90vw',
        maxHeight: '90vh',
        minWidth: isMobile ? '280px' : '300px',
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        zIndex: 9999,
        margin: 0
      }}
    >
      <div className={styles.windowHeader}>
        <span>{t('windows.welcome.title')}</span>
        <Button onClick={handleClose} size="sm">
          <span>✕</span>
        </Button>
      </div>
      <div 
        className={styles.windowContent}
        style={{
          maxHeight: 'calc(90vh - 80px)',
          overflowY: 'auto',
          overflowX: 'hidden',
          WebkitOverflowScrolling: 'touch'
        }}
      >
        <div className={styles.aboutContainer} style={{ padding: isMobile ? '0 4px' : '0 8px' }}>
          <h1 className={styles.aboutTitle} style={{ fontSize: isMobile ? '18px' : '24px' }}>
            {t('windows.welcome.mainTitle')}
          </h1>
          
          <p style={{ 
            marginBottom: isMobile ? '12px' : '16px', 
            fontSize: isMobile ? '13px' : '14px',
            lineHeight: '1.4'
          }}>
            {t('windows.welcome.greeting')}
          </p>
          
          <Separator />
          
          <div className={styles.aboutSection} style={{ marginBottom: isMobile ? '12px' : '20px' }}>
            <h2 style={{ fontSize: isMobile ? '14px' : '16px' }}>{t('windows.welcome.important')}</h2>
            <p style={{ fontSize: isMobile ? '13px' : '14px', lineHeight: '1.4' }}>{t('windows.welcome.importantText')}</p>
          </div>
          
          <Separator />
          
          <div className={styles.aboutSection} style={{ marginBottom: isMobile ? '12px' : '20px' }}>
            <h2 style={{ fontSize: isMobile ? '14px' : '16px' }}>{t('windows.welcome.whatToDo')}</h2>
            <ul style={{ fontSize: isMobile ? '13px' : '14px', lineHeight: '1.4' }}>
              {t('windows.welcome.todoList').map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </div>
          
          <Separator />
          
          <div className={styles.aboutSection} style={{ marginBottom: isMobile ? '12px' : '20px' }}>
            <p style={{ fontSize: isMobile ? '13px' : '14px', lineHeight: '1.4', fontStyle: 'italic' }}>{t('windows.welcome.tips')}</p>
          </div>
          
          <Separator />
          
          <div className={styles.aboutSection} style={{ marginBottom: isMobile ? '12px' : '20px' }}>
            <h2 style={{ fontSize: isMobile ? '14px' : '16px' }}>{t('windows.welcome.navigation')}</h2>
            <p style={{ fontSize: isMobile ? '13px' : '14px', lineHeight: '1.4' }}>{t('windows.welcome.navigationTip')}</p>
          </div>
          
          <div style={{ 
            display: 'flex', 
            flexDirection: isMobile ? 'column' : 'row',
            justifyContent: 'space-between', 
            alignItems: isMobile ? 'stretch' : 'center',
            gap: isMobile ? '12px' : '0',
            marginTop: isMobile ? '16px' : '20px',
            paddingTop: isMobile ? '12px' : '16px',
            borderTop: '1px solid #c0c0c0'
          }}>
            <div style={{ 
              display: 'flex', 
              alignItems: 'center', 
              gap: '8px',
              justifyContent: isMobile ? 'center' : 'flex-start'
            }}>
              <Checkbox 
                checked={dontShow} 
                onChange={() => setDontShow(!dontShow)}
              />
              <span style={{ fontSize: isMobile ? '11px' : '12px' }}>{t('windows.welcome.dontShowAgain')}</span>
            </div>
            <Button 
              onClick={handleClose} 
              primary
              style={{ 
                fontSize: isMobile ? '13px' : '14px',
                padding: isMobile ? '16px 16px' : '8px 16px',
                marginBottom: isMobile ? '12px' : '0'
              }}
            >
              {t('windows.welcome.closeButton')}
            </Button>
          </div>
        </div>
      </div>
    </Window>
  );
};

export default WindowWelcome; 